import { Dropdown } from 'primereact/dropdown';
import React, { useState, useEffect } from 'react';
import { Dialog } from 'primereact/dialog';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { useSelector } from 'react-redux';
import { useGetCoachingInsightHistoryQuery } from '../CoachingInsightSlice';
import { datetimeToDate } from '../../../utils/dateFormat';
import { CoachingInsightSummary } from '../../coachingInsightSummary/CoachingInsightSummary';
import './CoachingInsightHistory.scss';
import StrengthsInActive from '../../../assets/Brain-1.svg';
import StrengthsActive from '../../../assets/Brain-2.svg';
import DiscussionLogsActive from '../../../assets/friend.png';
import DiscussionLogsInActive from '../../../assets/friend-1.svg';
import NewStrength from '../../../features/coaching/strengths/newStrength/NewStrength';
import { CoachingEntityTypes, CoachingTabs } from '../../../utils/typeConstants';
import { selectCurrentEmpid, selectCurrentUser, selectCurrentUserManagerLevel } from '../../../pages/login/authSlice';
import CoachingToDo from '../../CoachingToDo/CoachingToDo';
import CoachingShoutOut from '../../coachingShoutOut/coachingShoutOUt';
import NewConversationLog from '../../../features/coaching/conversationLogs/newConversationLog/NewConversationLog';
import { CopyConfirmationDialog } from '../CopyConfirmationDialog';
import ReadConversationLog from '../../../features/coaching/conversationLogs/readConversationLog/ReadConversationLog';
import ReadStrengths from '../../../features/coaching/strengths/readStrengths/ReadStrengths';
import CoachingToDoView from '../../CoachingToDo/CoachingToDoView';
import { ROLES } from '../../../constants';

interface InsightHistoryProps {
    agentNumber: string;
    setShowInsightsHistoryModal: (value: boolean) => void;
    showInsightsHistoryModal: boolean;
}

export const CoachingInsightHistory = ({
    agentNumber,
    setShowInsightsHistoryModal,
    showInsightsHistoryModal,
}: InsightHistoryProps) => {
    const [selectedDate, setSelectedDate] = useState<string>('');
    const [selectedDateRange, setSelectedDateRange] = useState<any>();
    const [expandedRows, setExpandedRows] = useState<any>();
    const [showNewStrengthModal, setShowNewStrengthModal] = useState(false);
    const [shoutoutVisible, setShoutoutVisible] = useState(false);
    const [todoVisible, setTodoVisible] = useState(false);
    const [showNewConversationModal, setshowNewConversationModal] = useState(false);
    const [viewState, setViewState] = useState<string>('new');
    const loggedEmpNum = useSelector(selectCurrentEmpid);
    const loggedEmpUserName = useSelector(selectCurrentUser);
    const [dialogVisible, setConfirmDialogVisible] = useState<boolean>(false);
    const [dialogHeader, setDialogHeader] = useState<string>('');
    const [dialogBody, setDialogBody] = useState<string>('');
    const [copyConfirmed, setCopyConfirmed] = useState<boolean | null>(null);
    const [coachingPoints, setCoachingPoints] = useState<any>(''); // eslint-disable-line
    const [strengths, setStrengths] = useState<any>('');
    const [actionBody, setActionBody] = useState<string>('');
    const [currentAction, setCurrentAction] = useState<string>('');
    const [currentRowData, setCurrentRowData] = useState<any>();
    const userManagerLevel = useSelector(selectCurrentUserManagerLevel);
    const calculateDate = (value: string) => {
        const currentDate = new Date();
        let calculatedDate = new Date();
        switch (value) {
            case 'lastMonth':
                calculatedDate.setMonth(currentDate.getMonth() - 1);
                break;
            case 'last3Months':
                calculatedDate.setMonth(currentDate.getMonth() - 3);
                break;
            case 'last6Months':
                calculatedDate.setMonth(currentDate.getMonth() - 6);
                break;
            case 'last9Months':
                calculatedDate.setMonth(currentDate.getMonth() - 9);
                break;
            case 'lastYear':
                calculatedDate.setFullYear(currentDate.getFullYear() - 1);
                break;
            default:
                calculatedDate = currentDate;
                break;
        }
        return calculatedDate;
    };
    const rangeOptions = [
        { label: 'Last Month', value: 'lastMonth' },
        { label: 'Last Three Months', value: 'last3Months' },
        { label: 'Last Six Months', value: 'last6Months' },
        { label: 'Last Nine Months', value: 'last9Months' },
        { label: 'Last Year', value: 'lastYear' },
    ];
    const { data: insightHistoryData } = useGetCoachingInsightHistoryQuery(
        {
            employeeNumber: agentNumber?.toString(),
            fromDate: datetimeToDate(selectedDateRange),
        },
        {
            skip: !agentNumber || !selectedDateRange,
        }
    );
    useEffect(() => {
        const defaultRange = calculateDate('last3Months');
        setSelectedDateRange(defaultRange);
        setSelectedDate('last3Months');
    }, [agentNumber]);

    const handleRangeChange = (e: any) => {
        const value = e.value;
        setSelectedDate(value);
        const calculatedDate = calculateDate(value);
        setSelectedDateRange(calculatedDate);
    };
    const rowExpansionTemplate = (rowData: any) => {
        return (
            <div className="card mt-1 border-0">
                <div className="card-header border-0" style={{ backgroundColor: '#ebf2f9', padding: '5px' }}>
                    Details
                </div>
                <CoachingInsightSummary
                    data={[rowData]}
                    setShowInsightsHistoryModal={() => true}
                    via="history"
                />
            </div>
        )
    };
    const renderHeader = () => {
        return (
            <div>
                <h3>Coaching Points History Grid</h3>
            </div>
        );
    };
    const allowExpansion = (rowData: any) => {

        if (rowData) return true;
        else return false;
    };
    const formatWeekRange = (rowData: any) => {
        const formatDate = (dateString: string) => {
            const date = new Date(dateString);
            return date.toLocaleDateString('en-US', { dateStyle: "medium" });
        };

        const start = formatDate(rowData.startDate);
        const end = formatDate(rowData.endDate);
        return `${start} to ${end}`;
    };
    const selectedDateTemplate = (option: any) => {
        if (option) {
            return (
                <div className="flex align-items-center">
                    <i className="pi pi-calendar mr-2" style={{ paddingRight: '5px' }} />
                    {option.label}
                </div>
            );
        }
        return null;
    };
    const handleActionsClick = (rowData: any, actionName: string) => {
        setCurrentRowData(rowData);
        setStrengths(rowData.positiveTips.trim());
        setCoachingPoints(rowData.negativeTips.trim());
        setCurrentAction(actionName);
        if(actionName === 'ToDo'){
            setActionBody('');
            if(rowData.todos){
                setViewState('new');
                setTodoVisible(true);
            }
            else if(rowData.negativeTips.trim() !== ''){
                    setViewState('new');
                    handleAction(actionName);}
                else{
                    setViewState('new');
                    setTodoVisible(true);
                }
        }
        else if(actionName === 'ShoutOut'){
            setActionBody('');
            if(rowData.shoutouts){
                setShoutoutVisible(true);
            }
            else if(rowData.positiveTips.trim() !== '')
                    handleAction(actionName);
                else
                    setShoutoutVisible(true);
        }
        else if(actionName === 'Strengths'){
            if(rowData.strengths){
                setViewState('read');
                setShowNewStrengthModal(true);
            }
            else if(rowData.positiveTips.trim() !== ''){
                setViewState('new');
                    handleAction(actionName);
            }
                else{
                    setViewState('new');
                    setShowNewStrengthModal(true);
                }
        }
        else if(actionName === 'Discussions'){
            if(rowData.discussions){
                setViewState('read');
                setshowNewConversationModal(true);
            }
            else if(rowData.negativeTips.trim() !== ''){
                setViewState('new');    
                handleAction(actionName);

            }
                else{
                    setViewState('new');
                    setshowNewConversationModal(true);
                }
        }
    };
    function getTextFromHTML(html:any) {
        const tempDiv = document.createElement('div');
        tempDiv.innerHTML = html;
        return tempDiv.innerText.trim();
    }
    useEffect(() => {
        if(copyConfirmed !== null && copyConfirmed === false){
            setActionBody('');
        }
        if (currentAction === 'Discussions') {
            if(copyConfirmed){
                setActionBody(getTextFromHTML(coachingPoints));
            }
            if(copyConfirmed !== null){
                setshowNewConversationModal(true);
            }
        }
        else if (currentAction === 'ToDo') {
            if(copyConfirmed){
                setActionBody(getTextFromHTML(coachingPoints));
            }
            if(copyConfirmed !== null){
                setTodoVisible(true);
            }
        } 
        else if(currentAction === 'Strengths'){
            if(copyConfirmed){
                setActionBody(getTextFromHTML(strengths));
            }
            if(copyConfirmed !== null){
                setShowNewStrengthModal(true);
            }
        }
        else if(currentAction === 'ShoutOut'){
            if(copyConfirmed){
                setActionBody(getTextFromHTML(strengths));
            }
            if(copyConfirmed !== null){
                setShoutoutVisible(true);
            }
        }
        setCopyConfirmed(null);
    }, [copyConfirmed]);
    const handleAction = (action: string) => {
        if(action === 'Discussions'){
            setConfirmDialogVisible(true);
            setDialogHeader('Copy coaching Points?');
            setDialogBody('Do you want to copy the Coaching Points to the Discussion?');
        }
        else if (action === 'Strengths'){
            setConfirmDialogVisible(true);
            setDialogHeader('Copy Strengths?');
            setDialogBody('Do you want to copy the Strengths to the Strengths document?');
        }
        else if (action === 'ShoutOut'){
            setConfirmDialogVisible(true);
            setDialogHeader('Copy Strengths?');
            setDialogBody('Do you want to copy the Strengths into the Shout Out?');
        }
        else if (action === 'ToDo'){
            setConfirmDialogVisible(true);
            setDialogHeader('Copy coaching Points?');
            setDialogBody('Do you want to copy the Coaching Points to the To Do?');
        }
    }
   
    const buttonTemplate = (rowData: any) => {
        return(
            /* eslint-disable jsx-a11y/click-events-have-key-events, jsx-a11y/no-static-element-interactions */
            /* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
            <div id='AcionIcons' style={{display:'flex'}}>
                <i className="pi pi-megaphone icons" style={{border:'1px solid', cursor:'pointer', 
                filter: rowData.shoutouts ? 'brightness(1) invert(1) sepia(3) saturate(50) hue-rotate(195deg)' : ''}}
                onClick={() => handleActionsClick(rowData,'ShoutOut') } 
                title={rowData.shoutouts ? 'Shout Out Created' : 'No Shout Out created'}
                />
                <i className="pi pi-comment icons" style={{border:'1px solid', filter: rowData.todos ? 'brightness(1) invert(1) sepia(3) saturate(50) hue-rotate(195deg)' : '',cursor:'pointer'}}
                onClick={() => handleActionsClick(rowData,'ToDo')} title={rowData.todos ? 'To Do Created' : 'No To Do created'}/>
                <img className='icons' style={{border: rowData.strengths ? '1px solid #2a8cff' : '1px solid black',cursor: (ROLES.Agents.includes(userManagerLevel)?rowData.strengths:true) ? 'pointer' : 'not-allowed'}}
                    src={rowData.strengths? StrengthsActive : StrengthsInActive} alt="Strengths" 
                    onClick={() => (ROLES.Agents.includes(userManagerLevel)? rowData.strengths:true) && handleActionsClick(rowData,'Strengths')} title={rowData.strengths ? 'Strength Created' : 'No Strength created'}/>            
                <img className='icons' style={{border: rowData.discussions ? '1px solid #2a8cff' : '1px solid black',cursor: (ROLES.Agents.includes(userManagerLevel)?rowData.discussions:true) ? 'pointer' : 'not-allowed'}}
                    src={rowData.discussions ? DiscussionLogsActive : DiscussionLogsInActive} alt="Discussion" 
                    onClick={() => (ROLES.Agents.includes(userManagerLevel)? rowData.discussions:true) && handleActionsClick(rowData,'Discussions')} title={rowData.discussions ? 'Discussion Created' : 'No Discussion created'}/>
            </div>
            /* eslint-enable jsx-a11y/click-events-have-key-events, jsx-a11y/no-static-element-interactions */
            /* eslint-enable jsx-a11y/no-noninteractive-element-interactions */
        );
    }
    const renderStrenghtsModal = () => {
        if (viewState === 'read') {
            return (
                <ReadStrengths
                    OnViewState={setViewState}
                    OnDisplayModal={setShowNewStrengthModal}
                    OnEditStrength={setShowNewStrengthModal}
                    displayModal={showNewStrengthModal}
                    authorId={loggedEmpNum}
                    recieverId={agentNumber}
                    receiverName={currentRowData?.agentNumber}
                    month={new Date(currentRowData?.startDate).getMonth()+1}
                    year={new Date(currentRowData?.startDate).getFullYear()}
                    via={CoachingTabs.CoachingInsights}
                    coachingEntityId={currentRowData?.coachingInsightId}
                />
            );
        } else if (viewState === 'new') {
            return (
                <NewStrength
                OnViewState={setViewState}
                OnDisplayModal={setShowNewStrengthModal}
                displayModal={showNewStrengthModal}
                authorId={loggedEmpNum}
                authorName={loggedEmpUserName}
                recieverId={agentNumber}
                receiverName={currentRowData?.agentNumber}
                parentStrengthViewState={'new'}
                via={CoachingTabs.CoachingInsights}
                month={new Date(currentRowData?.startDate).getMonth()+1}
                year={new Date(currentRowData?.startDate).getFullYear()}
                coachingEntityId={currentRowData?.coachingInsightId}
                coachingEntityTypeId={CoachingEntityTypes.CoachingInsights}
                strengthDesc={actionBody}
            />
            );
        }
        return '';
    };
    const renderDiscussionModal = () => {
        if (viewState === 'read') {
            return (
                <ReadConversationLog
                    setViewState={setViewState}
                    setDisplayModal={setshowNewConversationModal}
                    viewState={viewState}
                    displayModal={showNewConversationModal}
                    authorId={loggedEmpNum}
                    authorName={loggedEmpUserName}
                    recieverId={agentNumber}
                    inputYear={new Date(currentRowData?.startDate).getFullYear()}
                    inputMonth={new Date(currentRowData?.startDate).getMonth()+1}
                    receiverName={currentRowData?.agentNumber}
                    via={CoachingTabs.CoachingInsights}
                    coachingEntityId={currentRowData?.coachingInsightId}
                    isRecipient
                />
            );
        } else if (viewState === 'new') {
            return (
                <NewConversationLog
                    setViewState={setViewState}
                    setDisplayModal={setshowNewConversationModal}
                    viewState={viewState}
                    displayModal={showNewConversationModal}
                    authorId={loggedEmpNum}
                    authorName={loggedEmpUserName}
                    recieverId={agentNumber}
                    receiverName={currentRowData?.agentNumber}
                    via={CoachingTabs.CoachingInsights}
                    date={new Date(currentRowData?.startDate)}
                    coachingEntityId={currentRowData?.coachingInsightId}
                    coachingEntityTypeId={CoachingEntityTypes.CoachingInsights}
                    discussionDesc={actionBody}
                />
            );
        }
        return '';
    };
    const renderTodoModal = () => {
        const match = currentRowData?.agentNumber.match(/\((\d+)\)/);
            let agentNumber = '';
            if (match) {
                agentNumber = match[1];
            }
        if(viewState === 'read'){            
            const todoView : any = {employeeNumber : agentNumber}
            return(
                <CoachingToDoView
                    visible={todoVisible}
                    setVisible={setTodoVisible}
                    selectedToDoViewData={todoView}
                    //via={CoachingTabs.CoachingInsights}
                    //coachingEntityId={currentRowData?.coachingInsightId}
                />
            );
        }
        else if(viewState === 'new'){
        return(
                    <CoachingToDo
                        receiverId={agentNumber}
                        receiverName={currentRowData?.agentNumber}
                        visible={todoVisible}
                        setVisible={setTodoVisible}
                        coachingEntityId={currentRowData?.coachingInsightId}
                        coachingEntityTypeId={CoachingEntityTypes.CoachingInsights}
                        coachingStatusId={1}
                        todoDescription={actionBody}
                        via={CoachingTabs.CoachingInsights}
                    />
        );
    }
    return '';
    }
    const renderShuotOutModal = () => {
        return(
        <CoachingShoutOut
                        receiverId={agentNumber}
                        receiverName={currentRowData?.agentNumber}
                        visible={shoutoutVisible}
                        setVisible={setShoutoutVisible}
                        coachingEntityId={currentRowData?.coachingInsightId}
                        coachingEntityTypeId={CoachingEntityTypes.CoachingInsights}
                        coreValueId={0}
                        shoutOutDescription={actionBody}  
                        via={CoachingTabs.CoachingInsights}                      
                    />
        );
    }
    return (
        <Dialog
            header={renderHeader()}
            visible={showInsightsHistoryModal}
            onHide={() => {
                setShowInsightsHistoryModal(false);
            }}
            modal
            draggable={false}
            resizable={false}
            style={{
                width: '1150px',
                height: '90vh',
            }}
        >
            <div className="row mt-2">
                <div className="col-md-2">
                    <label htmlFor="goal-date">Date Range</label>
                    <Dropdown
                        className='mt-1'
                        value={selectedDate}
                        options={rangeOptions}
                        onChange={handleRangeChange}
                        placeholder="Select Range"
                        valueTemplate={selectedDateTemplate}
                    />
                </div>
            </div>
            <div className="row">
                <DataTable
                    id='coaching-summary'
                    className='coaching-insight-history'
                    value={insightHistoryData?.data}
                    rows={5}
                    paginator={insightHistoryData?.data?.length > 5}
                    paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
                    rowsPerPageOptions={[5, 10, 25, 50]}
                    currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
                    emptyMessage="No records found."
                    rowExpansionTemplate={rowExpansionTemplate}
                    expandedRows={expandedRows}
                    onRowToggle={(e) => {
                        setExpandedRows(e.data);
                    }}
                >
                    <Column header="Associate" field="agentNumber" style={{ width: '3rem' }}
                        sortable />
                    <Column
                        header="Week"
                        style={{ width: '3rem' }}
                        sortable
                        sortField='startDate'
                        body={formatWeekRange}
                    />
                    <Column
                        header="No. of Calls"
                        field="callCount"
                        sortable
                        style={{ width: '3rem' }}
                    />
                    <Column
                    header={''}                    
                    style={{ width: '5rem' }}
                    body={(rowData: any) => buttonTemplate(rowData)}
                />
                    <Column key="expand" expander={allowExpansion} style={{ width: '1rem',textAlign:'center' }} />
                </DataTable>
                {showNewConversationModal && renderDiscussionModal()}
                {showNewStrengthModal && renderStrenghtsModal()}
                {todoVisible && renderTodoModal()}
                {shoutoutVisible && renderShuotOutModal()}
                <CopyConfirmationDialog
                dialogVisible={dialogVisible}
                setDialogVisible={setConfirmDialogVisible}
                dialogHeader={dialogHeader}
                dialogBody={dialogBody}
                setCopyConfirmed={setCopyConfirmed}
            />
            </div>
        </Dialog>
    );
};